import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestPayments({
  payload: { page = 0, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get('/admin/payment_methods', {
        params: {
          page,
          limit,
        },
      })
    );

    yield put(
      actions.savePayments({
        data: {
          ...response.data,
          limit,
        },
      })
    );
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestpayment() {
  yield takeEvery(actions.requestPayments, requestPayments);
}

function* deletePayment({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/payment_methods/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      Router.back();
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherDeletePayment() {
  yield takeLatest(actions.deletePayment, deletePayment);
}

const paymentSagas = function* root() {
  yield all([fork(watcherRequestpayment), fork(watcherDeletePayment)]);
};
export { paymentSagas };
